<div id="content" class="main-content">
     <div class="container">
        <div class="col-12 pl-0">
           <div class="crumbs breadcrumbs-style-2">
              <ul class="breadcrumb">
                 <li class="mt-3"><a class="pointer" routerLink="/dashboard"><i class="flaticon-home-fill"></i></a></li>
                 <li class="mt-3"><a class="pointer" routerLink="/support">Mes demandes</a></li>
                 <li class="active mt-3 current_arian"><a href="javascript:void(0);" class="current_arian">Nouvelle demande</a></li>
              </ul>
           </div>
        </div>
         <div class="page-header">
            <div class="page-title mt-3 row col-lg-12 col-md-12 d-flex justify-content-between">
               <h2 style="color:black">Besoin d'aide?</h2>
               <div *ngIf="newTicketLoading" class="cp-spinner cp-bubble" style="margin: auto;display: block;margin-left: 21px;
                  margin-bottom: 1%;">
               </div>
               <div class="alert alert-gradient alert-danger" 
                  id="profil_added" role="alert" style="background-image: linear-gradient(135deg,#30648fed 0,#009de6c4 100%) !important; display: none;"> 
                  <i class="flaticon-cancel-12 close ml-3" data-dismiss="alert"></i> 
                  <strong>Le dépôt du ticket</strong> a été ajouté avec succès.
               </div>
               <div class="alert alert-gradient alert-danger" 
                  id="profil_not_added" role="alert" style="background-image: linear-gradient(135deg,#8f3030ed 0,#e60000c4 100%) !important;display: none;"> 
                  <i class="flaticon-cancel-12 close ml-3" data-dismiss="alert"></i> 
                  <strong>Le dépôt du ticket a échoué</strong> Veuillez réessayer plus tard
               </div>
               <div class="alert alert-gradient alert-danger" 
                  id="file_max" role="alert" style="background-image: linear-gradient(135deg,#8f3030ed 0,#e60000c4 100%) !important;display: none;"> 
                  <i class="flaticon-cancel-12 close ml-3" data-dismiss="alert"></i> 
                  Vous pouvez télécharger un <b>maximum de 3 fichiers</b>.
               </div>
            </div>
         </div>
       <form class="form-login" [formGroup]="helpForm"  novalidate>
          <div class="row layout-spacing">
             <!-- COLUMN OF FORMULAIRE -->
             <div class="col-lg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 col-12 layout-spacing">
                <div class="statbox widget box box-shadow">
                   <div class="widget-content widget-content-area" style="border-top-right-radius: 6px;
                      border-top-left-radius: 6px;">                      
                      <div class="row form-group mb-3 mt-1">
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                           <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
                              <select class="mdl-textfield__input " id="object" name="object" formControlName="object">
                                 <option value="Dysfonctionnement">Dysfonctionnement</option>
                                 <option value="Erreur/Modification">Erreur/Modification</option>
                                 <option value="Autre">Autre</option>
                              </select>
                              <label class="mdl-textfield__label" for="object">Objet <span style="color: red;"><b>*</b></span></label>
                           </div>
                        </div>
                        <div *ngIf="role=='adm' || role=='asst'" class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
                                <select class="mdl-textfield__input " id="user" name="user" formControlName="user">
                                    <option *ngFor="let item of users" [value]="item.uuid">
                                       {{ capitalizeFirstLetter(item.fullname) }}
                                     </option>
                                </select>
                              <label class="mdl-textfield__label" for="user">Demandé par <span style="color: red;"><b>*</b></span></label>
                           </div>
                        </div>
                     </div>
                     <div class="row form-group mb-3 mt-1">
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                           <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
                                <select class="mdl-textfield__input " id="intensite" name="intensite" formControlName="intensite">
                                    <option value="Faible">Faible</option>
                                    <option value="Moyen">Moyen</option>
                                    <option value="Elevé">Elevé</option>
                                </select>
                                <label class="mdl-textfield__label" for="intensite"> Niveau d'intensité </label>
                           </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <div class="row flex-column">
                              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                 <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
                                    <label class="custom-file-container__custom-file" >
                                        <input type="file" id="pj" class="mdl-textfield__input  custom-file-container__custom-file__custom-file-input upload__inputfile" formControlName="pj" name="pj" accept="image/*" multiple=""
                                            data-max_length="20" (change)="addPic($event)">
                                        <input type="hidden" name="MAX_FILE_SIZE" value="10485760" />
                                        <span class="custom-file-container__custom-file__custom-file-control"></span>
                                        <label class="mdl-textfield__label" for="pj"> Pièce jointe</label>
                                    </label>
                                </div>
                              </div>
                              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                 <div class="upload__img-wrap"></div>
                              </div>
                            </div>
                         </div>
                     </div>
                     <div class="row form-group mb-3 mt-1">
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                           <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
                              <textarea type="text" class="mdl-textfield__input" id="desc" name="desc" formControlName="desc"  maxlength="1000" style="height: 100px;"></textarea>
                              <label class="mdl-textfield__label" for="desc"> Descriptif <span style="color: red;"><b>*</b></span></label>
                           </div>
                        </div>
                     </div>

                    </div>
                </div>
             </div>
             <div class="col-lg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 col-12 layout-spacing">
                <div class="l-a-load-more pt-2 actions_buttons d-flex justify-content-center">
                   <button type="reset" class="btn progress-button btn-rounded mb-2 pr-5 pl-5 mr-2" style="background-color: #bac5ed;" routerLink="/absence">
                      Annuler
                   </button>
                   <button id="loading-circle-notification" class="btn btn-gradient-success btn-rounded mb-2 mr-2 pr-5 pl-5"
                   (click)="saveTicket()" [disabled]="helpForm.invalid">Déposer le ticket</button>
                   </div>
             </div>
          </div>
       </form>
     </div>
  </div>    